/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { BrandColors, MaterialIcon, Tooltip } from '@blend/enterprise-components';
import { hasVirus } from '../utils';
import { BlendBridge } from 'blb-types/blendBridge';

const TOOLTIP_POSITIONING: Tooltip.Props['position'] = 'bottom-start';
const INDICATOR_SIZE = 16;

const styles = StyleSheet.create({
  tooltipWrapper: {
    cursor: 'default',
    width: INDICATOR_SIZE,
  },
});

export interface DocumentIndicatorColumnProps {
  document: BlendBridge.API.Document;
}

export const DocumentIndicatorColumn: React.FC<DocumentIndicatorColumnProps> = ({ document }) => {
  const documentHasVirus = hasVirus(document);
  if (documentHasVirus) {
    return (
      <div className={css(styles.tooltipWrapper)}>
        <Tooltip position={TOOLTIP_POSITIONING} text="Virus detected. No downloads will be allowed.">
          <MaterialIcon color={BrandColors.ACCENT_RED} size={INDICATOR_SIZE} type="error" />
        </Tooltip>
      </div>
    );
  }
  return null;
};
